import styles from './Dropdown.module.scss';
import { ChevronUp, ChevronDown } from 'lucide-react';

export interface DropdownHeaderProps {
  title: string;
  isListOpen: boolean;
  isSelected: boolean;
  onClick: () => void;
}
const DropdownHeader = ({
  title,
  isListOpen,
  isSelected,
  onClick,
}: DropdownHeaderProps) => {
  const arrow = isListOpen ? <ChevronUp /> : <ChevronDown />;

  return (
    <div className={styles.dropdownHeaderContainer} onClick={onClick}>
      <div className={styles.dropdownHeader}>
        <span
          className={`${styles.headerTitle} ${
            isSelected ? '' : styles.headerTitlePlaceholder
          }`}
        >
          {title}
        </span>
        {arrow}
      </div>
    </div>
  );
};

export default DropdownHeader;
